import appInvoices from "../../views/appPlans/invoices.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "invoices";
  const params = [
    "page",
    "limit",
    "paid",
    "status",
    "captain",
    "cash_collection_status",
  ];

  $stateProvider.state("invoices", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appInvoices,
      },
    },
    reloadOnSearch: false,
    data: { title: "Invoices" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/invoices/invoices.urls.js